export class Dependente {
  public id: number;
  public idApi: number;
  public nomeDependente: string;
  public cpfResponsavel: number;
}
